import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f1e6dfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenant-payments-for-processing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This process will post credits to Tenant and Landlord accounts and deduct Management Fees for Rent payments.", -1))
const _hoisted_3 = { class: "process-tenants-payment-filters" }
const _hoisted_4 = { class: "filter-column" }
const _hoisted_5 = { class: "filter-column" }
const _hoisted_6 = { class: "filter-column" }
const _hoisted_7 = { class: "payments-grid-container" }
const _hoisted_8 = { class: "commission-cell" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "due-cell" }
const _hoisted_13 = { class: "received-cell" }
const _hoisted_14 = ["onMouseover"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onMouseover"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onMouseover"]
const _hoisted_19 = ["onClick"]

import { computed, inject, ref, watch, onMounted, nextTick } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { TenantPaymentItem } from "@/types/accounts/TenantPaymentItem";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import EditTenantPaymentModal from "@/components/accounts/edit-tenant-payment-modal.vue";
import { TenantPaymentsToProcess } from "@/types/accounts/TenantPaymentsToProcess";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { RentsToPayAPIFilters } from "@/types/tenancies/RentsToPayAPIFilters";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { FieldSize } from "@/enums/system/FieldSize";
import NumberDropdown from "@/components/ui/dropdowns/number-dropdown.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import FieldValidationFreeDateBox from "@/components/ui/inputs/field-validation-free-date-box.vue";
import moment from "moment";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { PaymentMethod } from "@/enums/tenancies/PaymentMethod";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { formatNumberIntoCurrency } from "@/utils/CurrencyFormatter";
import { DefaultContactType } from "acquaint-api/constants/DefaultContactType";
import ContactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import PropertyPeekModal from "@/components/properties/property-peek-modal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'process-tenant-payments-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * This is the selected bank accountn and is used to set the default value for the bank account filter and to retrieve the payments to process.
   * @type {number}
   * @required
   */
  bankAccountId: {
    type: Number,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

watch(
  () => showModal.value,
  (newValue) => {
    if (!newValue) {
      return;
    }
    resetValues();
  },
);

onMounted(async () => {
  currentUserPermissions.value = await userPermissionStore.getUserPermissions();
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const onCancelClick = () => (showModal.value = false);
const selectedPayment = ref<TenantPaymentItem>();
const payments = ref<TenantPaymentItem[]>([]);
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const loading = ref(false);
const showEditReceivedModal = ref(false);
const userPermissionStore = useUserPermissionsStore();
const currentUserPermissions = ref<UserPermissions>();
const selectedFilters = ref<RentsToPayAPIFilters>({
  bankAccountId: props.bankAccountId,
  daysOverdue: 0,
  onlyIncludeCurrentTenancies: false,
  landlordId: -1,
  dueDate: moment().toISOString(),
});
const recievedDate = ref(moment().toISOString());
const paymentMethod = ref(PaymentMethod.StandingOrder);
const disableAllButtons = ref(false);
const propertyIconId = ref(0);
const contactIconId = ref(0);
const landlordIconId = ref(0);
const contactToBePeeked = ref(0);
const contactPeekTitle = ref("");
const displayContactPeekModal = ref(false);
const propertyToBePeeked = ref(0);
const propertyPeekTitle = ref("");
const displayPropertyPeekModal = ref(false);

const fetchPayments = async (): Promise<TenantPaymentItem[]> => {
  try {
    return await apiClient.httpPost(
      `app/tenancy/retrievesrentstopay`,
      fetchPaymentsFilters.value,
    );
  } catch (error) {
    displayErrorMessage(getErrorMessage(error));
    return [];
  }
};

const fetchAndHandleData = async () => {
  loading.value = true;
  const initialPayments: TenantPaymentItem[] = await fetchPayments();
  payments.value = initialPayments.map((payment: TenantPaymentItem) => {
    return {
      ...payment,
      include: false,
    };
  });

  initialPayments.forEach((payment) => {
    payment.include = false;
  });

  payments.value = initialPayments;
  selectedPayment.value = undefined;
  loading.value = false;
};

const fetchPaymentsFilters = computed(() => {
  const filters = new RentsToPayAPIFilters();
  filters.bankAccountId = selectedFilters.value.bankAccountId;
  filters.daysOverdue = selectedFilters.value.daysOverdue;
  filters.onlyIncludeCurrentTenancies =
    selectedFilters.value.onlyIncludeCurrentTenancies;
  filters.landlordId = selectedFilters.value.landlordId;
  return filters;
});

const resetValues = () => {
  paymentMethod.value = PaymentMethod.StandingOrder;
  selectedFilters.value.onlyIncludeCurrentTenancies = false;
  selectedFilters.value.landlordId = -1;
  selectedFilters.value.daysOverdue = 0;
  selectedFilters.value.bankAccountId = props.bankAccountId;
  selectedFilters.value.dueDate = moment().toISOString();
  disableAllButtons.value = false;
};

watch(
  () => selectedFilters.value,
  async () => {
    if (!showModal.value) {
      return;
    }
    disableAllButtons.value = false;
    await fetchAndHandleData();
  },
  { deep: true },
);

const onRowClick = (e: TenantPaymentItem) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
  showEditReceivedModal.value = true;
};

const onRowSelected = (e: TenantPaymentItem) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
};

const tenantPaymentsToProcess = computed(() => {
  const paymentsToProcess: TenantPaymentsToProcess = {
    bankAccountId: selectedFilters.value.bankAccountId,
    receivedDate: recievedDate.value,
    paymentMethodId: paymentMethod.value,
    payAdvancedRentToLandlord: false,
    payments: payments.value
      .filter((payment) => payment.include)
      .map((payment) => {
        return {
          id: payment.id,
          receivedDate: recievedDate.value,
          receivedAmount: payment.due,
          landlordId: payment.landlordId,
          referenceChequeNo: payment.referenceChequeNo,
          receivedFromContactId: payment.received,
        };
      }),
  };

  return paymentsToProcess;
});

const onRunClick = async () => {
  disableAllButtons.value = true;
  if (!(await processedPayments())) {
    disableAllButtons.value = false;
    return;
  }
  disableAllButtons.value = false;
  fetchAndHandleData();
  standardInfoAlert(
    "Process complete. Tenant and Landlord accounts have been credited and Management Fees deducted.",
  );
};

const processedPayments = async () => {
  try {
    await apiClient.httpPostVoid(
      `app/tenancy/tenantpayments`,
      tenantPaymentsToProcess.value,
    );
    return true;
  } catch (error) {
    displayErrorMessage(getErrorMessage(error));
    return false;
  }
};

const onEditReceivedClick = () => {
  showEditReceivedModal.value = true;
};

const paymentUpdated = async (updatedRecord: TenantPaymentItem) => {
  payments.value = payments.value.map((payment) => {
    if (payment.id === updatedRecord.id) {
      return updatedRecord;
    }
    return payment;
  });
};

const selectedPaymentsCount = computed(() => {
  return payments.value.filter((payment) => payment.include).length.toString();
});

const totalRentReceieved = computed(() => {
  return formatNumberIntoCurrency(
    payments.value
      .filter((payment) => payment.include)
      .reduce((total, payment) => total + payment.received, 0),
    currentUser.value?.countryCodeID,
  );
});

const atLeastOnePaymentSelected = computed(() => {
  return payments.value.some((payment) => payment.include);
});

const fieldWidths = computed(() => {
  if (screen.width < 769) {
    return FieldSize.Full;
  }
  return FieldSize.Large;
});

const displayPropertyIcon = (id: number) => {
  propertyIconId.value = id;
};

const hidePropertyIcon = () => {
  propertyIconId.value = 0;
};

const peekProperty = (propertyId: number, propertyAddress: string) => {
  propertyToBePeeked.value = propertyId;
  propertyPeekTitle.value = propertyAddress;
  displayPropertyPeekModal.value = true;
};

const displayContactIcon = (id: number) => {
  contactIconId.value = id;
};

const hideContactIcon = () => {
  contactIconId.value = 0;
};

const showPeek = (contactId: number, contactName: string) => {
  contactToBePeeked.value = contactId;
  contactPeekTitle.value = contactName;
  displayContactPeekModal.value = true;
};

const displayLandlordIcon = (id: number) => {
  landlordIconId.value = id;
};

const hideLandlordIcon = () => {
  landlordIconId.value = 0;
};

const onIncludeChanged = (payment: TenantPaymentItem) => {
  nextTick();
  payment.include = !payment.include;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showModal).value = $event)),
      title: "Process Tenant Payments",
      height: "800px",
      width: _unref(ModalWidth).XLarge
    }, {
      "non-scrollable-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(FieldValidationFreeDateBox, {
                modelValue: selectedFilters.value.dueDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFilters.value.dueDate) = $event)),
                label: "Due Date",
                width: fieldWidths.value,
                "min-date": new Date()
              }, null, 8, ["modelValue", "width", "min-date"]),
              _createVNode(NumberDropdown, {
                modelValue: selectedFilters.value.daysOverdue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFilters.value.daysOverdue) = $event)),
                itemNumber: 99,
                label: "Days Overdue",
                allowZeroValue: true,
                customFirstValue: "All",
                "item-label-extension": "+",
                width: fieldWidths.value
              }, null, 8, ["modelValue", "width"]),
              _createVNode(FieldValidationFreeDateBox, {
                modelValue: recievedDate.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((recievedDate).value = $event)),
                label: "Received Date",
                width: fieldWidths.value,
                "max-date": new Date()
              }, null, 8, ["modelValue", "width", "max-date"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(LookupSingleSelect, {
                modelValue: paymentMethod.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentMethod).value = $event)),
                label: "Payment Method",
                lookupSource: _unref(LookupTableSource).PaymentMethods,
                width: fieldWidths.value
              }, null, 8, ["modelValue", "lookupSource", "width"]),
              _createVNode(LookupSingleSelect, {
                modelValue: selectedFilters.value.bankAccountId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedFilters.value.bankAccountId) = $event)),
                label: "Bank Account",
                lookupSource: _unref(LookupTableSource).BankAccounts,
                width: fieldWidths.value
              }, null, 8, ["modelValue", "lookupSource", "width"]),
              _createVNode(ContactLookup, {
                modelValue: selectedFilters.value.landlordId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedFilters.value.landlordId) = $event)),
                fetchInitialName: false,
                label: "Specific Landlord",
                showClearIcon: true,
                showSearch: true,
                showNavigateContactIcon: false,
                width: fieldWidths.value,
                readOnly: false,
                "display-peek": true,
                typeToFind: _unref(DefaultContactType).Landlord
              }, null, 8, ["modelValue", "width", "typeToFind"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AcquaintInfoBox, {
                label: "Total Rent Received",
                text: totalRentReceieved.value,
                width: fieldWidths.value
              }, null, 8, ["text", "width"]),
              _createVNode(AcquaintInfoBox, {
                label: "Count",
                text: selectedPaymentsCount.value,
                width: fieldWidths.value
              }, null, 8, ["text", "width"]),
              _createVNode(SwitchToggle, {
                modelValue: selectedFilters.value.onlyIncludeCurrentTenancies,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFilters.value.onlyIncludeCurrentTenancies) = $event)),
                label: "Only Include Current Tenancies",
                "read-only": false
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(GridBase, {
              "data-source": payments.value,
              "id-column-name": "id",
              loading: loading.value,
              "show-action-button": true,
              onRowClick: onRowClick,
              onRowSelected: onRowSelected,
              wordWrapEnabled: true,
              "show-search-panel": false,
              customColumnSlots: [
              'commissionCell',
              'includeCell',
              'dueCell',
              'receivedCell',
              'propertyCell',
              'contactCell',
              'landlordCell',
            ]
            }, {
              columns: _withCtx(() => [
                _createVNode(_unref(DxColumn), {
                  "data-field": "id",
                  caption: "ID",
                  visible: false
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "dueDate",
                  "data-type": "date",
                  caption: "Due Date",
                  width: "85px",
                  "hiding-priority": 10,
                  format: "dd/MM/yyyy"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "overdue",
                  caption: "Overdue",
                  "hiding-priority": 9,
                  width: "75px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "contact",
                  caption: "Contact",
                  width: "150px",
                  "hiding-priority": 11,
                  "cell-template": "contactCell"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "reference",
                  caption: "Reference",
                  "hiding-priority": 8,
                  width: "85px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "landlord",
                  caption: "Landlord",
                  "hiding-priority": 7,
                  "cell-template": "landlordCell",
                  width: "150px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "property",
                  caption: "Property",
                  "hiding-priority": 6,
                  "cell-template": "propertyCell",
                  width: "150px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "commissionFee",
                  width: "75px",
                  caption: "Comm.",
                  "hiding-priority": 5,
                  "cell-template": "commissionCell"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "due",
                  caption: "Due",
                  "hiding-priority": 3,
                  "cell-template": "dueCell",
                  width: "85px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "received",
                  caption: "Received",
                  "hiding-priority": 2,
                  "cell-template": "receivedCell",
                  width: "100px"
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "referenceChequeNo",
                  caption: "Ref/Cheque No",
                  "hiding-priority": 1
                }),
                _createVNode(_unref(DxColumn), {
                  "data-field": "include",
                  caption: "Include",
                  width: "125px",
                  "hiding-priority": 12,
                  "cell-template": "includeCell"
                })
              ]),
              commissionCellData: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_8, [
                  (
                    data.commissionFee > 0 && data.commissionPercentage == 0
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(data.commissionFee), 1))
                    : _createCommentVNode("", true),
                  (
                    data.commissionFee == 0 && data.commissionPercentage > 0
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(data.commissionPercentage) + "%", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              includeCellData: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "include-cell",
                  onClick: () => onIncludeChanged(data)
                }, [
                  _createVNode(SwitchToggle, {
                    "model-value": data.include,
                    "read-only": false
                  }, null, 8, ["model-value"])
                ], 8, _hoisted_11)
              ]),
              dueCellData: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(formatNumberIntoCurrency)(data.due, currentUser.value?.countryCodeID)), 1)
              ]),
              receivedCellData: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatNumberIntoCurrency)(
                    data.received,
                    currentUser.value?.countryCodeID,
                  )), 1)
              ]),
              propertyCellData: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "property-cell",
                  onMouseover: ($event: any) => (displayPropertyIcon(data.id)),
                  onMouseleave: hidePropertyIcon
                }, [
                  (propertyIconId.value == data.id)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: ($event: any) => (peekProperty(data.propertyId, data.property)),
                        class: "fas fa-user"
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(data.property), 1)
                ], 40, _hoisted_14)
              ]),
              contactCellData: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "contact-cell",
                  onMouseover: ($event: any) => (displayContactIcon(data.id)),
                  onMouseleave: hideContactIcon
                }, [
                  (contactIconId.value == data.id)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: ($event: any) => (showPeek(data.contactId, data.contact)),
                        class: "fas fa-user"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(data.contact), 1)
                ], 40, _hoisted_16)
              ]),
              landlordCellData: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "landlord-cell",
                  onMouseover: ($event: any) => (displayLandlordIcon(data.id)),
                  onMouseleave: hideLandlordIcon
                }, [
                  (landlordIconId.value == data.id)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: ($event: any) => (showPeek(data.landlordId, data.landlord)),
                        class: "fas fa-user"
                      }, null, 8, _hoisted_19))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(data.landlord), 1)
                ], 40, _hoisted_18)
              ]),
              _: 1
            }, 8, ["data-source", "loading"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Edit Received',
          onClick: () => {
            onEditReceivedClick();
          },
          disabled: !selectedPayment.value || disableAllButtons.value,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Run',
          onClick: () => {
            onRunClick();
          },
          disabled:
            !currentUserPermissions.value?.financialOptions.tenantpayments ||
            !atLeastOnePaymentSelected.value ||
            disableAllButtons.value,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Close',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    (selectedPayment.value)
      ? (_openBlock(), _createBlock(EditTenantPaymentModal, {
          key: 0,
          modelValue: showEditReceivedModal.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showEditReceivedModal).value = $event)),
          "tenant-payment": selectedPayment.value,
          onPaymentUpdated: paymentUpdated
        }, null, 8, ["modelValue", "tenant-payment"]))
      : _createCommentVNode("", true),
    _createVNode(ContactsPeekPopup, {
      modelValue: displayContactPeekModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((displayContactPeekModal).value = $event)),
      "contact-id": contactToBePeeked.value,
      title: contactPeekTitle.value
    }, null, 8, ["modelValue", "contact-id", "title"]),
    _createVNode(PropertyPeekModal, {
      modelValue: displayPropertyPeekModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((displayPropertyPeekModal).value = $event)),
      "property-id": propertyToBePeeked.value,
      title: propertyPeekTitle.value
    }, null, 8, ["modelValue", "property-id", "title"])
  ], 64))
}
}

})